export const APPEARANCE_BADGE_SEEN_KEY = 'paire.appearance.badge.seen';

export function hasSeenAppearanceBadge(): boolean {
  return localStorage.getItem(APPEARANCE_BADGE_SEEN_KEY) === 'true';
}

export function markAppearanceBadgeSeen(): void {
  localStorage.setItem(APPEARANCE_BADGE_SEEN_KEY, 'true');
}
